export default __webpack_public_path__ + "static/media/Abhijeet Vichare.d19c97fe.jpg";